import React from "react";

/**
 * Inline sparkle mark for the "Salesgear AI" identity (assistant avatar +
 * command-palette "Ask AI"). Rendered as SVG on purpose: the Material Icons
 * `auto_awesome` glyph is absent from the app's pinned v8 icon font and renders
 * blank, so we don't rely on it. Fill follows `currentColor`.
 */
const SparkleIcon = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M11.5 2.5l1.62 4.63 4.63 1.62-4.63 1.62L11.5 15l-1.62-4.63L5.25 8.75l4.63-1.62z" />
    <path d="M18 13.5l.86 2.39 2.39.86-2.39.86-.86 2.39-.86-2.39-2.39-.86 2.39-.86z" />
  </svg>
);

export default SparkleIcon;
